import * as RadixTabs from "@radix-ui/react-tabs";
import { ComponentProps, ElementType } from "react";
import clsx from "classnames";

export type TabsRootType = ComponentProps<ElementType> & {
  defaultValue?: string;
  onValueChange: (value: string) => void;
  value: string;
};

export const Tabs = ({ children, defaultValue, value, onValueChange, className, ...rest }: TabsRootType) => {
  return (
    <RadixTabs.Root
      className={clsx("flex flex-col group bg-background-surface", className)}
      defaultValue={defaultValue}
      onValueChange={onValueChange}
      value={value}
      {...rest}
    >
      {children}
    </RadixTabs.Root>
  );
};

export type TabsListType = RadixTabs.TabsListProps;
export const TabsList = ({ children, className, ...rest }: TabsListType) => {
  return (
    <RadixTabs.List className={clsx("shrink-0 flex border-b border-neutral-300", className)} {...rest}>
      {children}
    </RadixTabs.List>
  );
};

export type TabsTriggerType = ComponentProps<ElementType> & {
  value: string;
  subtitle?: string;
  disabled?: boolean;
};

export const TabsTrigger = ({ children, value, className, disabled, subtitle, ...rest }: TabsTriggerType) => {
  return (
    <RadixTabs.Trigger
      className={clsx(
        "py-4 px-2 flex flex-col gap-1 flex-1 justify-center items-center leading-none select-none",
        "data-[state=active]:text-platform-600 data-[state=active]:shadow-[inset_0_-2px_0_0,0_1px_0_0]",
        "bg-background-surface hover:bg-background-surface-neutral",

        className
      )}
      value={value}
      disabled={disabled}
      {...rest}
    >
      {children}

      {subtitle && (
        <span className="text-xs text-text-base-secondary font-normal data-[state=active]:font-normal">{subtitle}</span>
      )}
    </RadixTabs.Trigger>
  );
};

export type TabsContentType = ComponentProps<ElementType> & { value: string };
export const TabsContent = ({ children, value, className, ...rest }: TabsContentType) => {
  return (
    <RadixTabs.Content
      className={clsx("data-[state=inactive]:hidden data-[state=active]:flex data-[state=active]:flex-1", className)}
      value={value}
      {...rest}
    >
      {children}
    </RadixTabs.Content>
  );
};

Tabs.List = TabsList;
Tabs.Trigger = TabsTrigger;
Tabs.Content = TabsContent;
